/**
 * Scénarios prédéfinis : référence (les gares du dossier), express, omnibus, vide.
 * Les terminus sont toujours conservés.
 */
import type { RouteData } from "./route";

export type PresetId = "reference" | "express" | "omnibus" | "vide";

export const PRESET_LABELS: Record<PresetId, string> = {
  reference: "Tracé de référence",
  express: "Express",
  omnibus: "Omnibus",
  vide: "Vide",
};

export function termini(route: RouteData): [number, number] {
  const s = route.reference_stations;
  return [s[0].idx, s[s.length - 1].idx];
}

export function presetStops(route: RouteData, preset: PresetId, omnibusTarget = 40): number[] {
  const ref = route.reference_stations.map((s) => s.idx);
  const [a, b] = termini(route);
  switch (preset) {
    case "reference":
      return [...ref];
    case "express":
      return route.reference_stations.filter((s) => s.express || s.idx === a || s.idx === b).map((s) => s.idx);
    case "vide":
      return [a, b];
    case "omnibus": {
      // on coupe en deux la plus longue interstation jusqu'à atteindre la cible
      const stops = [...ref];
      while (stops.length < omnibusTarget) {
        let best = 0;
        let bestLen = 0;
        for (let k = 0; k < stops.length - 1; k++) {
          const len = stops[k + 1] - stops[k];
          if (len > bestLen) {
            bestLen = len;
            best = k;
          }
        }
        if (bestLen < 2) break;
        stops.splice(best + 1, 0, Math.round((stops[best] + stops[best + 1]) / 2));
      }
      return stops;
    }
  }
}
